<template>
    <div class="add" >
        <el-row>
            <el-col :span="12">
                <div class="grid-content bg-purple" style="margin-top:15px;margin-left:10%;margin-right:15px ">
                    <el-card shadow="always">
                        <el-form ref="item" :model="item"  label-width="100px" >
                            <el-form-item label="品牌名称">
                                <el-input v-model="item.brand"  placeholder="请输入品牌名称" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="商品名称">
                                <el-input v-model="item.name"  placeholder="请输入商品名称" clearable></el-input>
                            </el-form-item>
                            <el-form-item  style="height:250px">
                              <el-col  :span="12">
                                <el-upload
                                  class="avatar-uploader"
                                  action="http://localhost:7777/goods/upload"
                                  :show-file-list="false"
                                  :before-upload="beforePictureUpload">
                                  <img v-if="this.item.picture" :src="this.item.picture" class="avatar">
                                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                  <div class="el-upload__tip" slot="tip">到样图</div>
                                </el-upload>
                              </el-col>
                              <el-col  :span="12">
                                <el-upload
                                  class="avatar-uploader"
                                  action="1111"
                                  :show-file-list="false"
                                  :before-upload="beforeSupplePictureUpload">
                                  <img v-if="this.item.supplePicture" :src="this.item.supplePicture" class="avatar">
                                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                  <div class="el-upload__tip" slot="tip">补样图</div>
                                </el-upload>
                              </el-col>
                            </el-form-item>
                            <el-form-item label="商品属性">
                                <el-select v-model="item.properties" multiple filterable placeholder="请选择" style="width:100%">
                                    <el-option
                                    v-for="property in properties"
                                    :key="property.value"
                                    :label="property.label"
                                    :value="property.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="所属店铺">
                                <el-input v-model="item.shop"  placeholder="请输入商品所属店铺"  clearable></el-input>
                            </el-form-item>
                            <el-form-item label="商品位置">
                                <el-input v-model="item.location"  placeholder="请输入商品位置"  clearable></el-input>
                            </el-form-item>
                            <el-form-item label="商品描述">
                                <el-input type="textarea" placeholder="请输入内容" v-model="item.description" :maxlength=textMaxLenth autosize> </el-input>
                            </el-form-item>
                            <el-form-item label="商品日常价格">
                              <el-col :span="10">
                                <el-input v-model="item.highPrice"  placeholder="请输入日常价" clearable></el-input>
                              </el-col>
                              <el-col class="line" :span="4">直播价</el-col>
                              <el-col :span="10">
                                <el-input v-model="item.lowPrice"  placeholder="请输入直播价" clearable></el-input>
                              </el-col>
                            </el-form-item>
                            <el-form-item label="到样时间">
                                <el-date-picker v-model="item.arrivalTime" type="date" placeholder="选择到样日期" style="width:100%"> </el-date-picker>
                            </el-form-item>
                            <el-form-item label="到样总数">
                                <el-input type="textarea" placeholder="请输入内容" v-model="item.num" :maxlength=textMaxLenth autosize> </el-input>
                            </el-form-item>
                            <el-form-item label="型号/规格">
                                <el-input v-model="item.specs"  placeholder="请输入型号/规格信息" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="材质/香型">
                                <el-input type="textarea" placeholder="请输入材质信息" v-model="item.material" :maxlength=textMaxLenth autosize></el-input>
                            </el-form-item>
                            <el-form-item label="颜色/口味">
                                <el-input type="textarea" placeholder="请输入内容" v-model="item.color" :maxlength=textMaxLenth autosize> </el-input>
                            </el-form-item>
                            <el-form-item label="到期时间">
                                <el-date-picker v-model="item.exp" type="date" placeholder="选择过期日期" style="width:100%"> </el-date-picker>
                            </el-form-item>
                            <el-form-item label="赠品">
                                <el-input type="textarea" v-model="item.gifts"  placeholder="请输入赠品信息" :maxlength=textMaxLenth autosize> </el-input>
                            </el-form-item>
                            <el-form-item label="通过试样">
                              <el-col :span="4">
                                <el-switch v-model="item.pass"></el-switch>
                              </el-col>
                              <el-col class="line" :span="2">备注</el-col>
                              <el-col :span="18">
                                <el-input type="textarea" placeholder="请输入内容" v-model="item.tryDetails" :maxlength=textMaxLenth autosize> </el-input>
                              </el-col>
                            </el-form-item>
                            <!-- <el-form-item label="排期">
                                <el-col :span="11">
                                  <el-date-picker type="date" placeholder="选择日期" v-model="item.scheduledFrom" style="width: 100%;"></el-date-picker>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                  <el-date-picker type="date" placeholder="选择日期" v-model="item.scheduledTo" style="width: 100%;"></el-date-picker>
                                </el-col>
                            </el-form-item> -->
                            <el-form-item label="已经拥有">
                                <el-checkbox-group v-model="item.has">
                                    <el-checkbox label="卖点卡" name="sellingPointCards"></el-checkbox>
                                    <el-checkbox label="商家卖点卡" name="merchantSellingPointCards"></el-checkbox>
                                    <el-checkbox label="比价图" name="PriceComparisonChart"></el-checkbox>
                                    <el-checkbox label="辅助文件" name="auxiliaryFiles"></el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item label="附件">
                                <el-upload
                                    class="upload-demo"
                                    action="http://localhost:7777/goods"
                                    :before-upload="handleBeforeUpload"
                                    :on-remove="handleRemove"
                                    :on-preview="handlePreview"
                                    :before-remove="beforeRemove"
                                    :file-list="item.fileList">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">立即创建</el-button>
                                <el-button @click="resetForm()">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </div>
            </el-col>

            <el-col :span="12">
                <div class="grid-content bg-purple" style="margin-top:15px;margin-left:10%;margin-right:10% ">
                    <el-row>
                        <el-card shadow="always">
                          <el-divider >补样</el-divider>
                            <el-form ref="item" :model="item" label-width="80px"  style="margin-top:7%">
                                <el-form-item label="补样时间"  >
                                    <el-date-picker v-model="item.suppleTime" type="date" placeholder="选择日期" style="width:100%"> </el-date-picker>
                                </el-form-item>
                                <el-form-item label="补样数量">
                                    <el-input type="textarea" placeholder="请输入内容" v-model="item.suppleNum" :maxlength=textMaxLenth autosize> </el-input>
                                </el-form-item>
                                <el-form-item label="备注" style="margin-bottom:7%">
                                    <el-input type="textarea" placeholder="请输入内容" v-model="item.suppleDetails" :maxlength=textMaxLenth autosize> </el-input>
                                </el-form-item>
                                <el-divider>退样</el-divider>
                                <el-form-item label="退样时间"  style="margin-top:7%">
                                    <el-date-picker v-model="item.returnTime" type="date" placeholder="选择日期" style="width:100%"> </el-date-picker>
                                </el-form-item>
                                <el-form-item label="退样地址">
                                    <el-input v-model="item.returnAddress"  placeholder="请输入地址" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="退样单号">
                                    <el-input v-model="item.returnNumber"  placeholder="请输入单号" clearable></el-input>
                                </el-form-item>
                                <el-form-item label="备注">
                                    <el-input type="textarea" placeholder="请输入内容" v-model="item.returnDetails" :maxlength=textMaxLenth autosize> </el-input>
                                </el-form-item>
                                <el-form-item label="退样图片" >
                                    <el-upload
                                        class="upload-demo"
                                        action="http://localhost:7777/goods"
                                        :on-remove="handleReturnRemove"
                                        :on-preview="handlePreview"
                                        :before-remove="beforeReturnRemove"
                                        :before-upload="handleReturnBeforeUpload"
                                        :file-list="item.returnFileList">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                    </el-upload>
                                </el-form-item>
                            </el-form>
                        </el-card>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Common from './Common'
export default {
  name: 'Add',
  data () {
    return {
      item: {
        brand: '',
        name: '',
        properties: [],
        highPrice: '',
        picture: '',
        supplePicture: '',
        lowPrice: '',
        shop: '',
        location: '',
        exp: '',
        gifts: '',
        description: '',
        arrivalTime: '',
        num: '',
        specs: '',
        material: '',
        color: '',
        tryDetails: '',
        pass: false,
        scheduledFrom: '',
        scheduledTo: '',
        has: [],
        suppleTime: '',
        suppleNum: '',
        suppleDetails: '',
        returnFileList: [],
        returnTime: '',
        returnAddress: '',
        returnNumber: '',
        returnDetails: '',
        fileList: []
      },
      properties: [],
      textMaxLenth: 300
    }
  },
  mounted () {
    this.getProperty()
  },
  methods: {
    getProperty () {
      this.$axios({
        method: 'get',
        url: Common.baseUrl + 'property/get'
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.properties = res.data.data
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    onSubmit () {
      let formData = new FormData()
      console.log(this.item)
      formData.append('item', this.item)
      this.$axios.post(Common.baseUrl + 'goods/save', this.item
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '保存商品成功！',
            type: 'success'
          })
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    resetForm () {
      Object.assign(this.$data, this.$options.data())
    },
    handleRemove (file) {
      for (var i = 0; i < this.item.fileList.length; i++) {
        if (this.item.fileList[i].uid === file.uid) {
          this.item.fileList.splice(i, 1)
          i--
        }
      }
    },
    handleBeforeUpload (file) {
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error('上传图片大小不能超过 10MB!')
        return
      }
      console.log('开始上传，上传的文件为：' + file)
      let formData = new FormData()
      formData.append('multipartFiles', file)
      this.$axios({
        method: 'post',
        url: Common.baseUrl + 'goods/upload',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '文件上传成功！',
            type: 'success'
          })
          let addFile = {
            'name': file.name,
            'url': res.data.data
          }
          console.log(res.data.data)
          this.item.fileList.push(addFile)
          console.log(this.item.fileList)
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    beforeRemove (file) {
      return this.$confirm('确定移除' + file.name + '?')
    },
    handleReturnRemove (file) {
      for (var i = 0; i < this.item.returnFileList.length; i++) {
        if (this.item.returnFileList[i].uid === file.uid) {
          this.item.returnFileList.splice(i, 1)
          i--
        }
      }
    },
    handleReturnBeforeUpload (file) {
      if (file.size / 1024 / 1024 > 10) {
        this.$message.error('上传图片大小不能超过 10MB!')
        return
      }
      console.log('开始上传，上传的文件为：' + file)
      let formData = new FormData()
      formData.append('multipartFiles', file)
      this.$axios({
        method: 'post',
        url: Common.baseUrl + 'goods/upload',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '文件上传成功！',
            type: 'success'
          })
          let addFile = {
            'name': file.name,
            'url': res.data.data
          }
          this.item.returnFileList.push(addFile)
          console.log(this.item.returnFileList)
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    beforeReturnRemove (file) {
      return this.$confirm('确定移除' + file.name + '?')
    },
    handlePreview (file) {
      window.open(file.url)
    },
    beforePictureUpload (file) {
      if (!this.vaildPicture(file)) return
      console.log('开始上传，上传的文件为：' + file)
      console.log(file)
      let formData = new FormData()
      formData.append('multipartFiles', file)
      this.$axios({
        method: 'post',
        url: Common.baseUrl + 'goods/upload',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '文件上传成功！',
            type: 'success'
          })
          this.item.picture = res.data.data
          console.log(this.item.picture)
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    beforeSupplePictureUpload (file) {
      if (!this.vaildPicture(file)) return
      console.log('开始上传，上传的文件为：' + file)
      let formData = new FormData()
      formData.append('multipartFiles', file)
      this.$axios({
        method: 'post',
        url: Common.baseUrl + 'goods/upload',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.$message({
            message: '文件上传成功！',
            type: 'success'
          })
          this.item.supplePicture = res.data.data
          console.log(this.item.supplePicture)
          this.$forceUpdate()
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    vaildPicture (file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 或者 PNG 格式!')
        return
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!')
        return
      }
      return isJPG && isLt10M
    }
  }
}
</script>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    width: 95%;
    line-height: 178px;
    /* position: relative; */
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    /* width: 178px;
    height: 178px; */
    /* max-width: 100%;
    max-height: 100%; */
    /* line-height: 178px; */
    /* width: 500%; */
    /* line-height: 500%; */
    text-align: center;
  }
  .avatar {
    width: 100%;
    height: 100%;
    max-height: 200px;
    /* width: 178px;
    height: 178px; */
    /* width: 50%;
    height: 50%; */
    /* width: 100px;
    height: 100px; */
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/additem.vue